import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { Modal, Button, FormControl, ControlLabel } from "react-bootstrap";
import Select from "react-select";
import ImageUploader from "react-images-upload";
import "react-select/dist/react-select.css";

import Dialog from "react-bootstrap-dialog";
import glamorous from "glamorous";
import Colors from "../../styles/colors";
import {
  addOrganization,
  updateOrganization,
  deleteOrganization
} from "./OrganizationsState";
import { ModalMode, OrganizationTypes } from "./OrganizationsView";

class OrganizationsModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      contactName: "",
      phoneNumber: "",
      email: "",
      freightVerifyId: "",
      selectedType: -1,
      base64Image: "",
      organization: null
    };

    this.onDrop = this.onDrop.bind(this);
    this.inputFieldsValid = this.inputFieldsValid.bind(this);
  }

  componentDidMount() {
    Dialog.setOptions({
      defaultOkLabel: "Yes",
      defaultCancelLabel: "No",
      primaryClassName: "btn-success"
    });
  }

  componentWillReceiveProps(nextProps) {
    const { show } = nextProps;
    const { organization } = this.state;
    if (!show) {
      this.setState({
        name: "",
        contactName: "",
        phoneNumber: "",
        email: "",
        freightVerifyId: "",
        selectedType: -1,
        base64Image: "",
        organization: null
      });
    }

    if (!_.isEqual(organization, nextProps.organization)) {
      const selectedType = _.findIndex(OrganizationTypes, {
        name: nextProps.organization ? nextProps.organization.org_type : ""
      });
      this.setState({
        name: nextProps.organization.org_name,
        contactName: nextProps.organization.contact_name,
        phoneNumber: nextProps.organization.phone_no,
        email: nextProps.organization.email_address,
        freightVerifyId: nextProps.organization.fv_id,
        selectedType: selectedType,
        base64Image: "",
        organization: nextProps.organization
      });
    }

    if (nextProps.organizationName) {
      const selectedType = _.findIndex(OrganizationTypes, {
        name: nextProps.organizationName
      });
      this.setState({
        selectedType: selectedType
      });
    }
  }

  inputFieldsValid() {
    const { name, email, selectedType } = this.state;
    const validEmail = email ? this.isValidEmail(email) : true;
    return name && validEmail && selectedType >= 0 ? true : false;
  }

  isValidEmail(address) {
    var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(address);
  }

  getActionBtnText(modalMode) {
    switch (modalMode) {
      case ModalMode.CREATE:
        return "Create";
      case ModalMode.UPDATE:
        return "Update";
      case ModalMode.DELETE:
        return "Delete";
      default:
        break;
    }
  }

  getActionBtnColor(modalMode) {
    switch (modalMode) {
      case ModalMode.CREATE:
        return Colors.highlight.GREEN;
      case ModalMode.UPDATE:
        return Colors.highlight.GREEN;
      case ModalMode.DELETE:
        return Colors.highlight.RED;
      default:
        break;
    }
  }

  getModalTitle(modalMode) {
    switch (modalMode) {
      case ModalMode.CREATE:
        return "Add New Organization";
      case ModalMode.UPDATE:
        return "Edit Organization";
      case ModalMode.DELETE:
        return "Delete Organization";
      default:
        break;
    }
  }

  onDrop(image) {
    if (image && image[0] instanceof Blob) {
      var reader = new FileReader();
      reader.readAsDataURL(image[0]);
      reader.onload = function() {
        this.setState({
          base64Image: reader.result
        });
      }.bind(this);
      reader.onerror = function(error) {
        console.log("Error: ", error);
      };
    }
  }

  render() {
    const {
      show,
      hide,
      modalMode,
      addOrganization,
      updateOrganization,
      deleteOrganization
    } = this.props;
    const {
      name,
      contactName,
      phoneNumber,
      email,
      freightVerifyId,
      selectedType,
      base64Image,
      organization
    } = this.state;

    const _this = this;
    const disabled =
      modalMode !== ModalMode.DELETE ? !this.inputFieldsValid() : false;
    const actionBtnTxt = this.getActionBtnText(modalMode);
    const actionBtnColor = this.getActionBtnColor(modalMode);
    const modalTitle = this.getModalTitle(modalMode);

    return (
      <Modal show={show} onHide={() => hide()}>
        <Modal.Header
          closeButton
          style={{
            padding: "0.5em",
            color: Colors.background.DARK_BLUE,
            backgroundColor: Colors.background.LIGHT_GRAY
          }}
        >
          <Modal.Title
            style={{
              fontWeight: "300"
            }}
          >
            {" "}
            {modalTitle}{" "}
          </Modal.Title>{" "}
        </Modal.Header>{" "}
        <Modal.Body
          style={{
            backgroundColor: Colors.background.LIGHT_GRAY
          }}
        >
          <glamorous.Div
            css={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              marginTop: "1em"
            }}
          >
            <glamorous.Div
              css={{
                width: "50%",
                color: "#acb5be"
              }}
            >
              <ControlLabel
                style={{
                  fontWeight: "normal"
                }}
              >
                {" "}
                Organization Name{" "}
              </ControlLabel>{" "}
              {modalMode === ModalMode.DELETE ? (
                <glamorous.P
                  css={{
                    fontWeight: 400,
                    fontStyle: "italic",
                    color: "black"
                  }}
                >
                  <strong> {organization ? organization.org_name : ""} </strong>{" "}
                </glamorous.P>
              ) : (
                <FormControl
                  style={{
                    backgroundColor: "white",
                    height: "3em",
                    boxShadow: "none"
                  }}
                  type="text"
                  value={name || ""}
                  //placeholder={'Name'}
                  onChange={evt =>
                    this.setState({
                      name: evt.target.value
                    })
                  }
                />
              )}{" "}
            </glamorous.Div>
            <glamorous.Div
              css={{
                width: "50%",
                color: "#acb5be",
                fontWeight: "normal"
              }}
            >
              <ControlLabel
                style={{
                  fontWeight: "normal"
                }}
              >
                {" "}
                Type{" "}
              </ControlLabel>{" "}
              {modalMode === ModalMode.DELETE ? (
                <glamorous.P
                  css={{
                    fontWeight: 400,
                    fontStyle: "italic",
                    color: "black"
                  }}
                >
                  <strong> {organization ? organization.org_type : ""} </strong>{" "}
                </glamorous.P>
              ) : (
                <Select
                  style={{
                    height: "3em"
                  }}
                  options={OrganizationTypes.map(t => {
                    return {
                      value: t.id,
                      label: t.name
                    };
                  })}
                  simpleValue
                  name="selected-state"
                  value={selectedType}
                  onChange={v =>
                    this.setState({
                      selectedType: v
                    })
                  }
                />
              )}{" "}
            </glamorous.Div>{" "}
          </glamorous.Div>

          <glamorous.Div
            css={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              marginTop: "1em"
            }}
          >
            <glamorous.Div
              css={{
                width: "50%",
                color: "#acb5be"
              }}
            >
              <ControlLabel
                style={{
                  fontWeight: "normal"
                }}
              >
                {" "}
                Email{" "}
              </ControlLabel>{" "}
              {modalMode === ModalMode.DELETE ? (
                <glamorous.P
                  css={{
                    fontWeight: 400,
                    fontStyle: "italic",
                    color: "black"
                  }}
                >
                  <strong>
                    {" "}
                    {organization ? organization.email_address : ""}{" "}
                  </strong>{" "}
                </glamorous.P>
              ) : (
                <FormControl
                  style={{
                    backgroundColor: "white",
                    height: "3em",
                    boxShadow: "none"
                  }}
                  type="text"
                  value={email || ""}
                  onChange={evt =>
                    this.setState({
                      email: evt.target.value
                    })
                  }
                />
              )}{" "}
            </glamorous.Div>

            <glamorous.Div
              css={{
                width: "50%",
                color: "#acb5be"
              }}
            >
              <ControlLabel
                style={{
                  fontWeight: "normal"
                }}
              >
                {" "}
                FreightVerify ID{" "}
              </ControlLabel>{" "}
              {modalMode === ModalMode.DELETE ? (
                <glamorous.P
                  css={{
                    fontWeight: 400,
                    fontStyle: "italic",
                    color: "black"
                  }}
                >
                  <strong> {organization ? organization.fv_id : ""} </strong>{" "}
                </glamorous.P>
              ) : (
                <FormControl
                  style={{
                    backgroundColor: "white",
                    height: "3em",
                    boxShadow: "none"
                  }}
                  type="text"
                  value={freightVerifyId || ""}
                  onChange={evt =>
                    this.setState({
                      freightVerifyId: evt.target.value
                    })
                  }
                />
              )}{" "}
            </glamorous.Div>
          </glamorous.Div>

          <glamorous.Div
            css={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              marginTop: "1em"
            }}
          >
            <glamorous.Div
              css={{
                width: "50%",
                color: "#acb5be"
              }}
            >
              <ControlLabel
                style={{
                  fontWeight: "normal"
                }}
              >
                {" "}
                Contact Name{" "}
              </ControlLabel>{" "}
              {modalMode === ModalMode.DELETE ? (
                <glamorous.P
                  css={{
                    fontWeight: 400,
                    fontStyle: "italic",
                    color: "black"
                  }}
                >
                  <strong>
                    {" "}
                    {organization ? organization.contact_name : ""}{" "}
                  </strong>{" "}
                </glamorous.P>
              ) : (
                <FormControl
                  style={{
                    backgroundColor: "white",
                    height: "3em",
                    boxShadow: "none"
                  }}
                  type="text"
                  value={contactName || ""}
                  onChange={evt =>
                    this.setState({
                      contactName: evt.target.value
                    })
                  }
                />
              )}{" "}
            </glamorous.Div>
            <glamorous.Div
              css={{
                width: "50%",
                color: "#acb5be"
              }}
            >
              <ControlLabel
                style={{
                  fontWeight: "normal"
                }}
              >
                {" "}
                Phone Number{" "}
              </ControlLabel>{" "}
              {modalMode === ModalMode.DELETE ? (
                <glamorous.P
                  css={{
                    fontWeight: 400,
                    fontStyle: "italic",
                    color: "black"
                  }}
                >
                  <strong> {organization ? organization.phone_no : ""} </strong>{" "}
                </glamorous.P>
              ) : (
                <FormControl
                  style={{
                    backgroundColor: "white",
                    height: "3em",
                    boxShadow: "none"
                  }}
                  type="text"
                  value={phoneNumber || ""}
                  onChange={evt =>
                    this.setState({
                      phoneNumber: evt.target.value
                    })
                  }
                />
              )}{" "}
            </glamorous.Div>{" "}
          </glamorous.Div>

          <glamorous.Div>
            {" "}
            {modalMode === ModalMode.DELETE ? null : (
              <ImageUploader
                withIcon={true}
                withPreview={true}
                singleImage={true}
                buttonText="Choose images"
                onChange={this.onDrop}
                imgExtension={[".png"]}
                maxFileSize={5242880}
              />
            )}{" "}
          </glamorous.Div>
        </Modal.Body>{" "}
        <Modal.Footer
          style={{
            backgroundColor: "#e2e2e2"
          }}
        >
          <Button
            style={{
              backgroundColor: "white",
              color: Colors.background.DARK_BLUE,
              marginRight: "0.5em"
            }}
            onClick={() => hide()}
          >
            {" "}
            Cancel{" "}
          </Button>{" "}
          <Button
            disabled={disabled}
            style={{
              backgroundColor: actionBtnColor,
              color: "white",
              fontWeight: "300"
            }}
            onClick={() => {
              if (modalMode === ModalMode.CREATE) {
                const payload = {
                  name: name,
                  email_address: email,
                  fv_id: freightVerifyId,
                  contact_name: contactName,
                  phone_no: phoneNumber,
                  organization_profile_id: selectedType
                    ? OrganizationTypes[selectedType].profile_id
                    : 0,
                  logo: base64Image
                };
                addOrganization(payload);
                hide();
              } else if (modalMode === ModalMode.UPDATE) {
                const payload = {
                  name: name,
                  email_address: email,
                  fv_id: freightVerifyId,
                  contact_name: contactName,
                  phone_no: phoneNumber,
                  organization_profile_id: selectedType
                    ? OrganizationTypes[selectedType].profile_id
                    : 0,
                  logo: base64Image
                };
                updateOrganization(organization.organization_id, payload);
                hide();
              } else if (modalMode === ModalMode.DELETE) {
                _this.dialog.show({
                  //title: 'Delete Confirmation',
                  body: "Are you sure you want to delete this organization?",

                  actions: [
                    Dialog.CancelAction(dialog => {
                      dialog.hide();
                    }),
                    Dialog.OKAction(() => {
                      deleteOrganization(organization.organization_id);
                      hide();
                    })
                  ],
                  bsSize: "small",
                  onHide: dialog => {
                    dialog.hide();
                    console.log("closed by clicking background.");
                  }
                });
              }
            }}
          >
            {" "}
            {actionBtnTxt}{" "}
          </Button>{" "}
          <Dialog
            ref={el => {
              this.dialog = el;
            }}
          />{" "}
        </Modal.Footer>{" "}
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    organizations: state.organizations.data
      ? state.organizations.data.response
      : state.organizations.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addOrganization: payload => dispatch(addOrganization(payload)),
    updateOrganization: (organizationId, payload) =>
      dispatch(updateOrganization(organizationId, payload)),
    deleteOrganization: organizationId =>
      dispatch(deleteOrganization(organizationId))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationsModal);



// WEBPACK FOOTER //
// ./src/modules/organizations/OrganizationsModal.js